//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
import "../no/DisplayableObject.js";
import "../no/ugmath.js";
let d=[[[0,"BasePlane",1,"DatumPlane",0],[0,"IntersectType",1,0],[0,"LabelColor",1,0],[0,"LabelDisplayType",1,0],[0,"LabelSettingInheritted",1,0],[0,"LineColor",1,0],[0,"LineFontType",1,0],[0,"LineSettingInheritted",1,0],[0,"LineWidthType",1,0]],[[["point1","point2","point3","point4"],"GetExtent",{R_:{valid:''}},0,0],[["point1","point2","point3","point4"],"SetExtent",{R_:{valid:''}},4,0],[["objectCount"],"GetIntersectedObjects",{R_:{intersectedObjects:"TaggedObject[]"}},0,0],[["intersectedObjects"],"SetIntersectedObjects",{},1,0],[["lineFontType"],"SetRealLineFontType",{},1,0],[[],"SwitchLabelLocationX",{},0,0],[[],"SwitchLabelLocationY",{},0,0],[[],"SwitchLabelLocationZ",{},0,0]],[]];
SPLM.Display.PlanarShipGridBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.PlanarShipGridBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.PlanarShipGridBuilder.IntersectOption = Object.freeze({
    "Everything" : "Everything", "SelectedObjects" : "SelectedObjects", "ShipGridAndSelected" : "ShipGridAndSelected"});

SPLM.Display.PlanarShipGridBuilder.LabelDisplayOption = Object.freeze({
    "ShowAll" : "ShowAll", "ShowEveryOther" : "ShowEveryOther", "ShowEveryThird" : "ShowEveryThird", "ShowEveryFourth" : "ShowEveryFourth", "HideAll" : "HideAll"});

export default SPLM;